
  import { defineComponent } from 'vue';

  import IconComponent from '@/common/ui/IconComponent.vue';

  import ButtonComponent from './ButtonComponent.vue';

  export default defineComponent({
    name: 'DownloadButton',
    components: { ButtonComponent, IconComponent },
    emits: ['click'],
    props: {
      text: {
        type: String,
        default: 'Скачать',
      },
      iconName: {
        type: String,
        default: 'downloadBlue',
      },
      mod: {
        type: String,
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
  });
